import { MenuItem, PermissionsResponseMenu } from "interfaces";
import { List, MonitorDot, PackageSearchIcon, ScrollText, ShieldCheck, ShieldEllipsis, ShoppingBag } from "lucide-react";

const menuIcons: Record<string, JSX.Element> = {
    security: <ShieldCheck />,
    admin: <ShieldEllipsis />,
    products: <PackageSearchIcon />,
    shopping: <ShoppingBag />,
    quotation: <List />,
    reports: <ScrollText />,
    default: <MonitorDot />,
  };

export const transformToMenu = (allowedPages: PermissionsResponseMenu[]): MenuItem[] => {
    const menuMap: Record<string, MenuItem> = {};
  
    allowedPages.forEach((item) => {
      const option = item.option;
      if (!option.mainmenu || !option.description || !option.url) return;
  
      const parentId = option.mainmenu.id.toString();
      const normalizedLabel = option.mainmenu.description?.trim().toLowerCase();
  
      if (!menuMap[parentId]) {
        menuMap[parentId] = {
          id: parentId,
          label: option.mainmenu.description,
          link: "/#",
          icon: menuIcons[normalizedLabel] || <ShieldCheck />,
          subItems: [],
        };
      }
  
      const formattedUrl = option.url.startsWith("/") ? option.url : `/${option.url}`;
      menuMap[parentId].subItems?.push({
        id: option.id.toString(),
        label: option.description,
        link: formattedUrl,
        parentId: parentId,
      });
    });
  
    return Object.values(menuMap);
  };
  